module.exports = vendors_tr_045a4820b17dacf47ca3;